import { Button, Layout, Menu } from 'antd';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useMemo, useState } from 'react';
// import HouseFillIcon from 'assets/icons/house-fill.svg';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { UserToken } from 'domain/entities/UserEntity';
import { setUnreadMessageCount } from 'presentation/redux/features/counter/chatCounterSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import {
    BsBookHalf,
    BsBuildings,
    BsCalculatorFill,
    BsHouse,
    BsInfoCircleFill,
    BsLightbulb,
    BsList,
    BsMailbox2,
    BsMegaphoneFill,
    BsPersonCircle,
    BsPlayBtnFill,
    BsQuestionCircle,
    BsQuestionSquare,
} from 'react-icons/bs';
import { commonHelpers } from 'utilities/helpers';
import Unauthorized from '../Unauthorized';


const { Content, Header } = Layout;
const HEADER_MENU_ICON_SIZE = 18;


const SUB_MENU = [
    {
        label: 'マイページ',
        key: PRIVATE_ROUTES.SUB.CU_003_01,
        icon: <BsPersonCircle size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: 'メッセージ',
        key: PRIVATE_ROUTES.SUB.CU_012_01,
        icon: <BsMailbox2 size={HEADER_MENU_ICON_SIZE} />,
        isNotification: true,
    },
    {
        label: 'お知らせ一覧',
        key: PRIVATE_ROUTES.SUB.CU_022_01,
        icon: <BsMegaphoneFill size={HEADER_MENU_ICON_SIZE} />,
        isNotification: false,
    },
    {
        label: 'シミュレーション',
        key: PRIVATE_ROUTES.SUB.CU_050_01,
        icon: <BsCalculatorFill size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: '物件データベース',
        key: PRIVATE_ROUTES.SUB.CU_055_01,
        icon: <BsBuildings size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: 'お役立ちコンテンツ',
        key: PRIVATE_ROUTES.SUB.CU_020_01,
        icon: <BsBookHalf size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: 'よくある質問',
        key: PRIVATE_ROUTES.SUB.CU_011_01,
        icon: <BsQuestionSquare size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: 'プライバシーポリシー',
        key: PRIVATE_ROUTES.SUB.CU_021_02,
        icon: <BsInfoCircleFill size={HEADER_MENU_ICON_SIZE} />,
    },
    {
        label: '利用規約',
        key: PRIVATE_ROUTES.SUB.CU_021_01,
        icon: <BsInfoCircleFill size={HEADER_MENU_ICON_SIZE} />,
    },
       {
        label: '個人情報の取り扱い',
        key: PRIVATE_ROUTES.SUB.CU_021_03,
        icon: <BsInfoCircleFill size={HEADER_MENU_ICON_SIZE} />,
    },
]




export const MenuItems2 = [];

interface props {
    userLocal?: UserToken | null;
    toSigninPage: () => void;
    toSignupPage: () => void;
    logoutApp: () => void;
    selectMenuItem: (value: any) => void;
    chosenItem: string[];
    children?: string | JSX.Element | JSX.Element[];
    isRendering: boolean;
    userStorageUseCase: UserStorageUseCaseInterface;
}

export const MenuHeaderView = ({
    logoutApp,
    selectMenuItem,
    chosenItem,
    children,
    isRendering,
    toSigninPage,
    userLocal,
    userStorageUseCase,
}: props) => {
    const dispatch = useAppDispatch();
    const Notification = ({ checkUrl }: { checkUrl?: string }) => {
        const notifyCounterSlice = useAppSelector((state) => state.notifyCounterSlice);
        const chatCounterSlice = useAppSelector((state) => state.chatCounterSlice);
        React.useEffect(() => {
            if (!checkUrl) return;
            //CHAT
            if (checkUrl == PRIVATE_ROUTES.SUB.CU_012_01) {
                setTotal(chatCounterSlice.value);
                return;
            }
            //NOTIFY
            if (checkUrl == PRIVATE_ROUTES.SUB.CU_022_01) {
                setTotal(notifyCounterSlice.value);
                return;
            }
        }, [checkUrl]);
        const [total, setTotal] = useState<number>(0);
        if (!total) return <></>;
        return (
            <div
                // style={{ background: '#EB5757', height: 30, width: 40, borderRadius: 16 }}
                style={{ height: 30, width: 40, borderRadius: 16 }}
                className="center-inside"
            >
                {total}
            </div>
        );
    };

    const [canAccess, setCanAccess] = useState<boolean>(false);

    const menuItems = useMemo(() => {
        const subMenus = commonHelpers.getListMenuDisplay(SUB_MENU, userLocal?.user)
        return [
            {
                label: 'ホーム',
                key: PRIVATE_ROUTES.SUB.CU_002_02,
                icon: <BsHouse size={HEADER_MENU_ICON_SIZE} />,
            },
            {
                label: '物件査定',
                key: PRIVATE_ROUTES.SUB.CU_056_01,
                icon: <BsBuildings size={HEADER_MENU_ICON_SIZE} />,
            },
            {
                label: '売り物件一覧',
                key: PRIVATE_ROUTES.SUB.CU_002_01,
                icon: <BsLightbulb size={HEADER_MENU_ICON_SIZE} />,
            },
            {
                label: 'メニュー',
                key: null,
                icon: <BsList size={HEADER_MENU_ICON_SIZE} />,
                children: subMenus,
            },
        ] as any;
    }, [userLocal]);

    useEffect(() => {
        if (chosenItem[0] === PRIVATE_ROUTES.SUB.CU_012_01) {
            dispatch(setUnreadMessageCount(0));
        }
    }, [chosenItem]);

    useEffect(() => {
        const userInfo = userStorageUseCase.getUserInfo();
        setCanAccess(commonHelpers.canAccess(window.location.pathname, userInfo?.user));
    }, [window.location.pathname]);

    const isSignedIn = useAppSelector((state) => state.user)?.isSignedIn;

    const allowNotification = (path: string) => {
        return !window.location.pathname.includes(path);
    };

    return (
        <Layout>
            <Header>
                <div className="header-content">
                    <img alt="logo" src={Logo} className="header-logo" />
                    <Menu
                        mode="horizontal"
                        defaultSelectedKeys={[menuItems[0].key]}
                        selectedKeys={chosenItem}
                        onClick={selectMenuItem}
                        className="header-menu"
                        items={menuItems}
                    />
                    <Button
                        className="header-login-button"
                        type="primary"
                        // style={{ height: 56, fontWeight: 700, fontSize: 16 }}
                        onClick={() => (isSignedIn ? logoutApp() : toSigninPage())}
                    >
                        {isSignedIn ? 'ログアウト' : 'ログイン'}
                    </Button>
                </div>
            </Header>
            {}
            <Content className="main-content">
                {isRendering ? canAccess ? children : <Unauthorized /> : <></>}
            </Content>
        </Layout>
    );
};
